// 02.7-settings.md §5/paso b -- extraído de WhatsPanel.jsx. Placeholder de configuración (§0.6-
// adyacente): 3 opciones sin funcionalidad real, no se le inventa comportamiento en este slice.
export default function WhatsSettingsView() {
  return (
    <div style={{ padding: "var(--space-5)", flex: 1, overflowY: "auto" }}>
      <h3 style={{ margin: "0 0 var(--space-5) 0", color: "#111" }}>
        Configuración
      </h3>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "10px",
        }}
      >
        <div
          style={{
            padding: "var(--space-3) var(--space-4)",
            background: "#f5f5f5",
            borderRadius: "var(--radius-md)",
            cursor: "pointer",
            fontWeight: "500",
            color: "#333",
          }}
        >
          Respuestas rápidas
        </div>
        <div
          style={{
            padding: "var(--space-3) var(--space-4)",
            background: "#f5f5f5",
            borderRadius: "var(--radius-md)",
            cursor: "pointer",
            fontWeight: "500",
            color: "#333",
          }}
        >
          Programar mensajes
        </div>
        <div
          style={{
            padding: "var(--space-3) var(--space-4)",
            background: "#f5f5f5",
            borderRadius: "var(--radius-md)",
            cursor: "pointer",
            fontWeight: "500",
            color: "#333",
          }}
        >
          Vincular con..
        </div>
      </div>
    </div>
  );
}
